import React from 'react'
import ProfilePage from '../components/profilePage/ProfilePage'

const UserProfileAdmin = () => {
  return (
    <><ProfilePage pageType="Admin"/></>
  )
}

export default UserProfileAdmin